export default __webpack_public_path__ + "static/media/app.c0fda68c.svg";